import React, { ReactNode } from "react";
import { motion, AnimatePresence as Transition } from "framer-motion";
import { height } from "styled-system";

const animatedSearchVariants = {
  enter: {
    maxHeight: "100%",
    opacity: 1,
    transition: { ease: "easeInOut", duration: 1 },
  },
  exit: { maxHeight: 0, opacity: 0, transition: { ease: "easeInOut", duration: 1 } },
};

export const AnimatedDiv = ({ children, css }: { children: ReactNode; css?: any }) => (
  <motion.div
    variants={animatedSearchVariants}
    initial="exit"
    animate="enter"
    exit="exit"
    style={{ overflow: "hidden" }}
    css={css}
  >
    {children}
  </motion.div>
);

export { Transition };
